export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getTukListlAction";
    Actions["GET_DETAIL"] = "getTukDetailAction";
    Actions["POST_DATA"] = "postTukAction";
    Actions["UPDATE_DATA"] = "putTukAction";
    Actions["DELETE_DATA"] = "deleteTukAction";
    Actions["CREATE_EXPORT"] = "createExportTukAction";
    Actions["CHANGE_EXPORT"] = "changeExportTukAction";
    Actions["DOWNLOAD"] = "downloadTukAction";
    Actions["UPLOAD_CREATE"] = "uploadCreateTukAction";
    Actions["UPLOAD_SUBMIT_CREATE"] = "uploadSubmitCreateTukAction";
    Actions["UPLOAD_CHANGE"] = "uploadChangeTukAction";
    Actions["UPLOAD_SUBMIT_CHANGE"] = "uploadSubmitChangeTukAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_ORDER"] = "setTukOrderByMutation";
    Mutations["SET_TUK_LIST"] = "setTukListMutation";
    Mutations["SET_TUK_LIST_LOADING"] = "setTukListLoadingMutation";
    Mutations["SET_TUK_LIST_PAGINATION"] = "setTukListPaginationMutation";
    Mutations["SET_TUK_LIST_FILTER"] = "setTukListFilterMutation";
    Mutations["RESET_TUK_LIST_FILTER"] = "resetTukListFilterMutation";
})(Mutations || (Mutations = {}));
